import React from "react"

const OutlookIcon = props => (
  <svg viewBox="0 0 66 44" {...props}>
    <path
      stroke="currentColor"
      opacity="0.5"
      fill="none"
      strokeWidth="4"
      strokeMiterlimit="10"
      d="M22.5,14v22 M10.5,24v12 M29,26v10 M35.5,30v6 M42,29v7 M16.5,20v16"
    />
    <g opacity="0.5">
      <path d="M25.2,15.9c-0.4,3.6,0.8,7.3,3.6,10.1c2.1,2.1,4.6,3.2,7.3,3.6V15.9H25.2z" />
      <path d="M48.3,10.8h-9v18.7c2.6-0.4,5.1-1.5,7.1-3.5C50.6,21.9,51.2,15.6,48.3,10.8z" />
    </g>
    <path
      fill="none"
      strokeWidth="5.1208"
      strokeMiterlimit="10"
      d="M57.3,36.8"
    />
    <path fill="none" strokeWidth="5.1208" strokeMiterlimit="10" d="M46.5,26" />
    <g stroke="currentColor" fill="none">
      <line
        strokeWidth="3"
        strokeMiterlimit="10"
        x1="46.5"
        y1="26"
        x2="57.3"
        y2="36.8"
      />
      <circle
        strokeWidth="3"
        strokeMiterlimit="10"
        cx="37.6"
        cy="17.2"
        r="12.5"
      />
    </g>
  </svg>
)

export default OutlookIcon
